/**
*功能: 顶部内容
*/

<template>
  <div id="logo-group">
    <span class="title">奥威ERP</span>
    <div class="vpoakLogo">
      <img src="../../assets/img/login/logo.png" class="IconImg" alt=""/>
      <span v-if="userInfor.userType==='0'">天津渤化ERP系统</span>
      <span v-else>天津渤化客户服务系统</span>
    </div>

    <!--<span id="activity" class="activity-dropdown"> <i class="fa fa-user"></i> <b class="badge"> 21 </b> </span>-->
    <div class="ajax-dropdown">
      <div class="btn-group btn-group-justified" data-toggle="buttons">
        <label class="btn btn-default" @click="currentTask='mail'">
          <input type="radio" name="activity">
          消息 (14)
        </label>
        <label class="btn btn-default" @click="currentTask='notifications'">
          <input type="radio" name="activity">
          通知 (3)
        </label>
        <label class="btn btn-default" @click="currentTask='task'">
          <input type="radio" name="activity">
          任务 (4)
        </label>
      </div>
      <div class="ajax-notifications custom-scroll">
        <component :is="currentTask"></component>
      </div>
      <span>Last updated on: 12/12/2013 9:43AM
        <button type="button" data-loading-text="<i class='fa fa-refresh fa-spin'></i> Loading..."
                class="btn btn-xs btn-default pull-right">
          <i class="fa fa-refresh"></i>
        </button>
      </span>
    </div>

    <div class="handle-warp">
      <el-dropdown class="el-dropdown-box">
        <span class="el-dropdown-link usr" style="cursor:pointer">
          <span class="userName">{{userInfor.nic}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="text-align:center;">
          <el-dropdown-item @click.native="showPassword=true">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="loginOut" divided>退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <i style="float: right" @click="toggleFullScreen()">
        <el-tooltip class="item" effect="dark" content="切换全屏" placement="bottom">
          <img src="../../assets/img/screenFull.png" class="dropIcon" style="width:20px;height:20px;"/>
        </el-tooltip>

      </i>
      <el-dropdown class="el-dropdown-style" trigger="click">
        <span class="el-dropdown-link" style="cursor:pointer;color:#fff;">
          <i>
            <el-tooltip class="item" effect="dark" content="皮肤" placement="bottom">
              <img src="../../assets/img/pifu.png" class="dropIcon" style="width:28px;height:28px;"/>
            </el-tooltip>
          </i>
        </span>
        <el-dropdown-menu slot="dropdown" style="text-align:center;">
          <el-dropdown-item @click.native="changeSkinS(0)" :disabled="skinIndex===0">正常</el-dropdown-item>
          <el-dropdown-item @click.native="changeSkinS(1)" :disabled="skinIndex===1">透明</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="guestNameTOP" v-if="userInfor.userType==='1'">{{Guest.name}}，欢迎你！</div>
    </div>
    <!-- <el-dialog
      title="修改密码"
      :visible.sync="showPassword"
      width="40%"
      center>
      <div style="margin-left: 25px">
        <i class="el-icon-info"></i>
        <span style="margin-left: 5px; color: #999999;">密码修改成功需重新登录</span>
      </div>
      <el-form style="margin-top: 10px" ref="form" :model="form" label-width="80px">
        <el-form-item label="密码：">
          <el-input style="width:150px;" type="password" v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPassword = false">取 消</el-button>
        <el-button type="primary" @click="updatePassword">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog title="修改密码" :visible.sync="showPassword" width="500px" center >
      <div style="width: 500px">
        <p align="center">
          <span style="color: red">*</span>
          密码必须包含
          <span style="color: #5151ff">
            大小写英文字母、数字和特殊符号
          </span>且
          <span style="color: #5151ff">
            长度至少为8位
          </span>。
        </p>
        <el-form style="margin-top: 10px" ref="form" :model="form" label-width="80px">
          <el-form-item :label="'新密码'" style="margin-bottom: 10px">
            <el-input style="width:200px;" type="text" :placeholder="'请输入新密码'"
              @input="(v) => { changeType(v, 'coverNewPassword', 'password', 'passwordRef1') }" id="passwordRef1"
              v-model.trim="form.coverNewPassword"></el-input>
          </el-form-item>
          <div v-if="!passwordSafety" class="SafetyBar" style="color: #ff6464">
            <i class="icon-label-off"></i>密码不符合安全等级
          </div>
          <el-form-item :label="'再次确认'" style="margin-bottom: 10px">
            <el-input style="width:200px;"
              @input="(v) => { changeType(v, 'coverAgain', 'passwordAgain', 'passwordRef2') }" id="passwordRef2"
              :placeholder="'请再次输入新密码'" v-model.trim="form.coverAgain" />
          </el-form-item>
          <div v-if="form.passwordAgain && form.passwordAgain !== form.password" class="SafetyBar"
            style="color: #ff6464"><i class="icon-label-off"></i>两次密码不一致
          </div>
        </el-form>
        <p align="center" class="tableLink" style="text-decoration: none;cursor: auto">
          修改密码成功后，需要重新登录，系统会帮您自动跳转到登录页 </p>
        <p style="height: 20px;color: #ff6464">
          <i v-show="passwordChangeError" style="margin-right: 10px;font-size: 18px"
            class="el-icon-circle-close"></i>{{ passwordChangeError }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPassword = false; clearData()">取 消</el-button>
        <el-button type="primary" @click="updatePassword">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import $ from 'jquery';
  import Mail from './comm/mail';
  import Notifications from './comm/notifications';
  import Task from './comm/task';
  import catchs from '@/mixins/catch.mixin';

  const skins = {
    0: {
      id: 0,
      name: '正常',
      className: 'normal',
      load: () => import('assets/skins/normal/normal.scss'),
    },
    1: {
      id: 1,
      name: '透明',
      className: 'glass',
      load: () => import('assets/skins/glass/glass.scss'),
    },
  };
  export default {
    name: 'topHeader',
    components: {Mail, Notifications, Task},
    mixins: [catchs],
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        currentSkin: 'skin/currentSkin',
        needUpdatePassword: 'user/needUpdatePassword',
      }),
      passwordSafety() {
        let t = 0
        let str = this.form.password
        if (!str) return true
        let symbol = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
        let num = new RegExp(/\d/)
        let upperCase = new RegExp(/[A-Z]/)
        let lowerCase = new RegExp(/[a-z]/)
        let arr = [symbol, num, upperCase, lowerCase]
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].test(str)) {
            t++
          }
        }
        if (str.length >= 8 && t === 4) {
          return true
        } else {
          return false
        }
      }
    },
    data() {
      return {
        currentTask: 'notifications',
        showPassword: false,
        form: {
          password: '',
          passwordAgain: '',
          coverPassword: '',
          coverNewPassword: '',
          again: '',
          coverAgain: ''
        },
        passwordChangeError:'',
        skinIndex: 0,
        fullscreen: false,
        Guest: {},
        forcedEditPassword: false,
      };
    },
    created() {
      this.userInforEven();
    },
    methods: {
      ...mapActions({
        delAllViews: 'tags/delAllViews',
        addClosedView: 'tags/addClosedView',
        changeSkin: 'skin/changeSkin',
        setUserInfor: 'user/setUserInfor',
        removeIsRemember: 'user/removeIsRemember',
      }),
      clearData(){
        this.form = {
          password: '',
          passwordAgain: '',
          coverPassword: '',
          coverNewPassword: '',
          again: '',
          coverAgain: ''
        }
        this.forcedEditPassword = false
        this.showPassword = false
      },
      changeType(val, key, key2, id) {
        let v = val.replace(/\s+/g, '')
        let index = -1
        let lastChar = ''
        let realArr = this.form[key2].split('')
        let coverArr = v.split('')
        let coverLen = v.length
        let realLen = this.form[key2].length
        coverArr.forEach((el, idx) => {
          if (el !== '●') {
            index = idx
            lastChar = lastChar + el
          }
        })
        if (lastChar.length) {
          index = index + 1 - lastChar.length
        }
        if (realLen + lastChar.length === coverLen) {
          realArr.splice(index, 0, lastChar)
        } else if (index === -1) {
          let pos = document.getElementById(id).selectionEnd
          realArr.splice(pos, realLen - coverLen)
        } else {
          realArr.splice(index, realLen + lastChar.length - coverLen, lastChar)
        }
        this.form[key] = v.replace(/\S/g, '●')
        this.form[key2] = realArr.join('')
        this.$nextTick(() => {
          if (index > -1) document.getElementById(id).setSelectionRange(index + lastChar.length, index + lastChar.length)
        })
      },

      FullScreen(el) {
        if (!this.fullscreen) {//退出全屏
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
          } else if (!document.msRequestFullscreen) {
            document.msExitFullscreen()
          }
        } else {    //进入全屏
          if (el.requestFullscreen) {
            el.requestFullscreen()
          } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen()
          } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
          } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen()
          }
        }
      },
      toggleFullScreen(e) {
        this.fullscreen = !this.fullscreen;
        var el = $('body')[0];//target兼容Firefox
        this.FullScreen(el);
      },
      loginOut() {
        this.$services.post({
          type: 'LOGIN',
          url: 'logout',
        });
        this.$utils.removeStorage({
          type: 'localStorage',
          key: 'TOKEN',
        });
        this.$utils.removeStorage({
          type: 'sessionStorage',
          key: 'LOGINANDOPEN',
        });
        this.removeIsRemember();
        this.$utils.removeStorage({
          type: 'cookie',
          key: 'JSESSIONID',
        });
        this.cachedViews.forEach(v => {
          this.addClosedView({name: v});
        });
        this.delAllViews();
        if (this.userInfor.userType === '0') {
          this.$router.push({name: 'servicelogin'});
        }
        else {
          this.$router.push({name: 'login'});
        }
      },
      async updatePassword() {
        let t = 0
        let symbol = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
        let num = new RegExp(/\d/)
        let letter = new RegExp(/[a-zA-Z]/)
        let arr = [symbol, num, letter]
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].test(this.form.password)) t++
        }
        if (this.form.password.length < 8 || t !== 3) {
          this.passwordChangeError = '密码长度至少8位，必须包含字母、数字和特殊符号';
          return
        }
        if (this.form.password!==this.form.passwordAgain) {
          this.passwordChangeError = '两次输入的密码不一致';
          return;
        }
        this.$services.getU({
          type: 'LOGIN',
          url: 'getEncryptInfo',
        }).then(keyIv => {
          this.loading = false;
          let {encryptIv, encryptKey} = keyIv.bean;
          let password = this.$utils.crypto.CryptoString(
            this.form.password,
            encryptKey,
            encryptIv,
          );
          let passwordOld = this.$utils.crypto.CryptoString(
            this.userInfor.passwordEnc,
            encryptKey,
            encryptIv,
          );
          this.showPassword = false;
          this.$services.post({
            type: 'LOGIN',
            url: 'chgPassword',
            params: {
              accountId: this.userInfor.accountId,
              operatorId: this.userInfor.userName,
              passwordOld,
              password,
            },
          }).then(({status}) => {
            if (status) {
              this.$message({
                message: '密码修改成功',
                type: 'success',
              });
              this.clearData();
              setTimeout(() => {
                this.loginOut();
              }, 2000);
            }
          });
        });
      },
      // 页面刷新重新设置vuex的urserInfor的数据内容
      userInforEven() {
        if (!this.userInfor.name) {
          let userInfor = this.$utils.getStorage({
            type: 'localStorage',
            key: 'userInfor',
          });
          this.setUserInfor(userInfor);
        }
        this.userInfor.userType === '1' ? this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getCurrentGuest',
          params: {
            accountId: this.userInfor.accountId
          },
        }).then(res => {
          if (res.code === '000') {
            this.Guest = res.bean;
            this.$utils.setStorage({
              type: 'localStorage',
              key: 'currentGuest',
              parameter: res.bean,
            });
          }
        }) : '';
      },
      changeSkinS(i) {
        this.skinIndex = i;
        document.body.className = skins[i].className;
        this.changeSkin(skins[i]);
      },
      initSkin() {
        document.body.className = this.currentSkin.className;
        if (this.currentSkin.name === '透明') {
          // eslint-disable-next-line global-require
          // this.skin = require('assets/skins/glass/glass.scss');
          this.skinIndex = 1;
          skins[1].load();
        }
        else {
          this.skinIndex = 0;
        }
      },
    },
    mounted() {
      this.clearData();
      this.initSkin();
      // this.$services.initSocket();
      // this.$services.connectSocket();
      // 延迟检查是否需要强制修改密码
      this.$nextTick(() => {
        if (this.needUpdatePassword) {
          this.showPassword = true
        }
      })
      $('#activity').click(function (e) {
        let $this = $(this);
        if ($this.find('.badge').hasClass('bg-color-red')) {
          $this.find('.badge').removeClassPrefix('bg-color-');
          $this.find('.badge').text('0');
        }
        if (!$this.next('.ajax-dropdown').is(':visible')) {
          $this.next('.ajax-dropdown').fadeIn(150);
          $this.addClass('active');
        }
        else {
          $this.next('.ajax-dropdown').fadeOut(150);
          $this.removeClass('active');
        }
        let theUrlVal = $this.next('.ajax-dropdown').find('.btn-group > .active > input').attr('id');

        $this = null;
        theUrlVal = null;
        e.preventDefault();
      });
      // setTimeout(() => {
      //   this.$notif.success({
      //     title: '新增装车单推送',
      //     content: '订单号1111122376推送成功',
      //     number: '0',
      //   });
      //   this.$notif.error({
      //     title: '卸货单推送',
      //     content: '订单号1111122376推送失败',
      //     number: '0',
      //   });
      // }, 1000);
      // let cindex = 1;
      // let interval = setInterval(() => {
      //   if (cindex === 2) {
      //     window.clearInterval(interval);
      //   }
      //   this.$notif.info({
      //     title: 'Info Message Example' + cindex,
      //     content: 'Lorem ipsum dolor sit amet, test consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
      //     number: '0',
      //   });
      //   cindex++;
      // }, 5000);
    },
  };
</script>

<style lang="scss">
/*  .el-container {
    min-width: 980px;
  }*/

  .title {
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    margin-left: 40px;
    color: #ffffff;
  }

  .guestNameTOP {
    display: inline-block;
    float: right;
    color: white;
  }

  .vpoakLogo {
    display: inline-block;
    margin: 5px 0;
    img{
      width: 40px;
    }
    span {
      display: inline-block;
      line-height: 100%;
      color: white;
      font-size: 16px;
      margin-left: 1em;
    }
  }

  .activity-dropdown, .title {
    display: inline-block;
    vertical-align: middle;
    margin-right: 45px;
  }

  .headerTitle-warp {
    display: inline-block;
    height: 60px;
    float: left;

    > span {
      display: block;
    }

    .title {
      font-size: 20px;
      padding: 5px 0 3px 0;
      color: #fff;
    }

    .text {
      font-size: 12px;
      color: #ccc;
    }
  }

  .handle-warp {
    height: 50px;
    line-height: 50px;
    float: right;
    position: relative;
    p {
      font-size: 12px;
      color: #ccc;
      margin: 5px 0;
      line-height: 30px;
      vertical-align: middle;
    }

    .el-dropdown-box {
      /* position: absolute;
       right: 20px;
       bottom: 10px;
       height: 30px;
       line-height: 30px;*/
      float: right;
      height: 3.5em;
    }

    .el-dropdown-style {
      /* position: absolute;
       right: 105px;
       bottom: 12px;
       height: 30px;
       line-height: 30px;*/
      float: right;
    }

    .usr {
      color: #ffffff;
      position: relative;
      padding-right: 1.5em;
      &:after {
        clear: both;
        display: inline-block;
        content: '';
      }
      .userName {
        display: inline-block;
        max-width: 15em;
        overflow: hidden;
        white-space: nowrap;
        word-break: break-all;
        text-overflow: ellipsis;
      }
      i {
        position: absolute;
        top: -1.5em;
        right: -1em;
      }
    }

    .dropIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
</style>
